import React, { useState } from 'react';
import Divider from '../../../components/misc/divider';
import Loader from '../../../components/misc/loader';
import { useBackPress } from '../../../hooks/useBackPress';
import { useScrollbarHide } from '../../../hooks/useScrollbarHide';
import SplitBillModal from '../../order/components/splitBill/modal';
import CheckoutHeader from './header';
import CheckoutPayment from './payment';
import CheckoutTips from './tips';
import CheckoutTotal from './total';

const CheckoutBill = ({
  restaurant,
  bill,
  order,
  table,
  onPay,
  paymentOption,
  disabled,
  onOpenBill,
  onBillSplitChange,
  onFail,
  paymentKey,
  allowTips,
}) => {
  useScrollbarHide(disabled);

  const [tipsAmount, setTipsAmount] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [splitModalOpen, setSplitModalOpen] = useState(false);

  const { handleBackOnModalOpen, handleBackOnModalClose } = useBackPress('/checkout', () =>
    setSplitModalOpen(false),
  );

  if (!bill) {
    return null;
  }

  const subtotal = (bill || {}).subtotal || 0;
  const totalDiscount = (bill || {}).discount || 0;
  const total = subtotal + (tipsAmount || 0) - totalDiscount;

  const isConfirmDisabled = () => {
    if (!total) {
      return true;
    }

    if (
      restaurant.allowTipsWaiterSelect &&
      restaurant.mustSelectWaiterForTip &&
      restaurant.employees &&
      restaurant.employees.length > 0 &&
      !selectedEmployee &&
      tipsAmount > 0
    ) {
      return true;
    }

    return false;
  };

  return (
    <div className="pt-6">
      <CheckoutHeader
        bill={bill}
        onEditSplit={() => {
          handleBackOnModalOpen();
          setSplitModalOpen(true);
        }}
        onOpenBill={onOpenBill}
      />
      {allowTips && (
        <>
          <CheckoutTips
            bill={bill}
            onChange={setTipsAmount}
            onChangeEmployee={(val) => setSelectedEmployee(val)}
            employees={restaurant.employees}
            allowWaiterSelect={restaurant.allowTipsWaiterSelect}
            preventSelectAllTeam={restaurant.mustSelectWaiterForTip}
          />
          <Divider className="mt-5 mb-5" />
        </>
      )}
      {/* <button
        type="button"
        className="font-primaryMedium text-primary text-sm underline"
        onClick={() => {}}
      >
        Do you have a promo code?
      </button> */}
      <CheckoutTotal subtotal={subtotal} total={total} tips={tipsAmount} discount={totalDiscount} />
      <CheckoutPayment
        paymentOption={paymentOption}
        onPay={({
          paymentType,
          paymentMethodId,
          dontDisable,
          paymentTrackId,
          paymentAccountId,
        }) => {
          onPay({
            paymentType,
            tips: tipsAmount,
            paymentMethodId,
            employeeId: selectedEmployee,
            dontDisable,
            paymentTrackId,
            paymentAccountId,
          });
        }}
        total={total}
        onFail={onFail}
        paymentKey={paymentKey}
        disabled={isConfirmDisabled()}
        allowCash={restaurant.allowCash}
        restaurant={restaurant}
        requireConfirmAlcohol={
          restaurant.requireConfirmAlcohol && bill.cart && bill.cart.find((x) => x.isAgeRestricted)
        }
      />
      {disabled && (
        <div className="fixed z-10 bg-white opacity-80 top-0 bottom-0 left-0 right-0 h-full">
          <Loader />
        </div>
      )}
      <SplitBillModal
        order={order}
        table={table}
        open={splitModalOpen}
        onToggle={(val) => {
          setSplitModalOpen(val);

          if (!val) {
            handleBackOnModalClose();
          }
        }}
        onConfirm={(splitType, data) => {
          onBillSplitChange(splitType, data);
          setSplitModalOpen(false);
          handleBackOnModalClose();
        }}
      />
    </div>
  );
};

export default CheckoutBill;
